/**
 * Web Vitals Tracking
 * Monitora e envia métricas de Core Web Vitals para analytics
 */

const THRESHOLDS = {
  LCP: 2500,
  FID: 100,
  CLS: 0.1,
  FCP: 1800,
  TTFB: 800,
};

function sendToAnalytics(metric) {
  const { name, value, id, delta } = metric;

  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", name, {
      value: Math.round(name === "CLS" ? value * 1000 : value),
      event_category: "Web Vitals",
      event_label: id,
      non_interaction: true,
      metric_name: name,
      metric_value: value,
      metric_delta: delta,
    });
  }

  if (process.env.NODE_ENV === "development") {
    const threshold = THRESHOLDS[name];
    const status = threshold && value > threshold ? "⚠️" : "✅";
    console.log(`${status} Web Vital [${name}]:`, {
      value:
        name === "CLS"
          ? value.toFixed(3)
          : `${value.toFixed(0)}${
              name === "LCP" || name === "FCP" || name === "TTFB"
                ? "ms"
                : name === "FID"
                ? "ms"
                : ""
            }`,
      threshold: threshold
        ? `${threshold}${name === "CLS" ? "" : "ms"}`
        : "N/A",
      status: threshold && value > threshold ? "ACIMA DO THRESHOLD" : "OK",
    });
  }

  if (process.env.NODE_ENV === "production") {
    const threshold = THRESHOLDS[name];
    if (threshold && value > threshold) {
      console.warn(`⚠️ ${name} acima do threshold:`, {
        value,
        threshold,
        delta: value - threshold,
      });
    }
  }
}

function getRating(name, value) {
  const thresholds = {
    LCP: { good: 2500, poor: 4000 },
    FID: { good: 100, poor: 300 },
    CLS: { good: 0.1, poor: 0.25 },
    FCP: { good: 1800, poor: 3000 },
    TTFB: { good: 800, poor: 1800 },
  };

  const threshold = thresholds[name];
  if (!threshold) return "unknown";
  if (value <= threshold.good) return "good";
  if (value <= threshold.poor) return "needs-improvement";
  return "poor";
}

function loadWebVitals() {
  return import(/* webpackChunkName: "web-vitals" */ "web-vitals");
}

/**
 * Inicializa tracking de Web Vitals (import dinâmico — fora do bundle inicial).
 */
export function initWebVitals() {
  if (typeof window === "undefined") return;

  const start = () => {
    loadWebVitals().then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(sendToAnalytics);
      getFID(sendToAnalytics);
      getFCP(sendToAnalytics);
      getLCP(sendToAnalytics);
      getTTFB(sendToAnalytics);
    });
  };

  if (document.readyState === "complete") {
    start();
  } else {
    window.addEventListener("load", start, { once: true });
  }
}

export function getWebVitalsMetrics() {
  return new Promise((resolve) => {
    const metrics = {};

    loadWebVitals().then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      const collectMetric = (name) => (metric) => {
        metrics[name] = {
          value: metric.value,
          rating: getRating(name, metric.value),
        };
        if (Object.keys(metrics).length === 5) {
          resolve(metrics);
        }
      };

      getCLS(collectMetric("CLS"));
      getFID(collectMetric("FID"));
      getFCP(collectMetric("FCP"));
      getLCP(collectMetric("LCP"));
      getTTFB(collectMetric("TTFB"));
    });
  });
}
